import 'app/agriculture/routes/BackOffice/UserHome/components/FarmCards/FarmCards.scss';
import { Heading } from 'app/agriculture/components/Heading/Heading';
import { FarmCardSkeleton } from '../FarmCard/FarmCardSkeleton';

export function FarmCardsSkeleton() {
    return (
        <div className="FarmCards">
            <Heading>Active farms</Heading>
            <div className="FarmCards__cards">
                <FarmCardSkeleton />
                <FarmCardSkeleton />
                <FarmCardSkeleton />
                <FarmCardSkeleton />
                <FarmCardSkeleton />
                <FarmCardSkeleton />
            </div>
        </div>
    );
}
